module.exports = __webpack_public_path__ + "img/screen2.e63578b5.jpg";